import { FC, useMemo } from "react";

import { useTheme } from "@mui/material";

import { getRichTextInputLinkStyles, getRichTextInputTextStyles } from "@/dashboard-design-system/RichTextInput";
import { deserialize } from "@/dashboard-design-system/RichTextInput/helpers";
import { FormExpandableText } from "@/forms-design-system/FormExpandableText";

type ThemedItemDescriptionProps = {
  active?: boolean;
  description: string;
};

export const ThemedItemDescription: FC<ThemedItemDescriptionProps> = ({ active = false, description }) => {
  const { isLexicalRichText: isRichDescription, value: parsedDescription } = useMemo(
    () => deserialize(description),
    [description]
  );

  const theme = useTheme();

  return (
    <FormExpandableText
      gradientOverlayHeight="20px"
      gradientOverlayColor={active ? theme.palette.forms.surface.supershy : theme.palette.background.default}
      maxHeight={{ xs: "40px", md: "60px" }}
      useTextButton
      data-test="themed-item-block-rate-description"
      amplitudeEventType="item"
      sx={(theme) => ({
        ...(isRichDescription && {
          ...getRichTextInputTextStyles(theme),
          ...getRichTextInputLinkStyles(theme.palette.forms.text.brand),
        }),
      })}
    >
      {parsedDescription}
    </FormExpandableText>
  );
};
